import { useEffect } from 'react';

import { createEffectWithTarget } from '#utilities/create-effect-with-target.util';

/**
 * A custom React hook that enhances the standard `useEffect` hook by allowing
 * effects to be bound to specific target elements or objects.
 *
 * This hook is created using the `createEffectWithTarget` utility, which
 * provides additional control over when the effect should run based on the
 * provided target(s).
 *
 * @see {@link createEffectWithTarget} for implementation details.
 * @see {@link https://react.dev/reference/react/useEffect | React useEffect documentation}
 *
 * @param effect - The effect callback function to run.
 * @param deps - An array of dependencies for the effect.
 * @param target - (Optional) The target element(s) or object(s) to bind the effect to.
 *
 * @returns void
 */
const useEffectWithTarget = createEffectWithTarget(useEffect);

export { useEffectWithTarget };
